import { NavigationFolder } from "@hub/models/ui/navigation-folder";
import { AnchorLink } from "@hub/ui/anchor-link";
import React from "react";
import styles from "./folders-nav.module.css";

interface FoldersNavProps {
  groupName: string;
  folders: NavigationFolder[];
}

export const FoldersNav: React.FC<FoldersNavProps> = ({
  groupName,
  folders,
}) => {
  return (
    <div className={styles.foldersNav}>
      <span className={styles.title}>Browse by {groupName}</span>
      <div className={styles.folders}>
        {folders.map((folder) => (
          <React.Fragment key={folder.path}>
            <AnchorLink to={folder.path} className={styles.folder}>
              <span className={styles.folderLabel}>{folder.label}</span>
            </AnchorLink>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
